"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useRouter_1 = require("../../contexts/useRouter/useRouter");
const string_1 = require("../../helpers/string/string");
const Card_styled_1 = require("./Card.styled");
const Card = ({ children, className, title, route, image, compact }) => {
    const { navigate } = (0, useRouter_1.useRouter)();
    return ((0, jsx_runtime_1.jsxs)(Card_styled_1.CardStyled, { className: (0, string_1.getClassName)('octo', compact && 'compact', className), onClick: () => navigate(route), children: [(0, jsx_runtime_1.jsx)("div", { className: "logo", children: (0, jsx_runtime_1.jsx)("img", { src: image, alt: "" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "panel", children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)("span", { children: title }) }), (0, jsx_runtime_1.jsx)("div", { className: "content", children: children })] })] }));
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map